// Using double quotes in this file to prevent issues with apostrophes (')
export default {
  header: {
    ai: {
      title: 'HP Nio fragen',
      close: 'Nio Chat schließen',
      open: 'Nio-Chat öffnen',
      morningGreeting: "Guten Morgen {0},",
      afternoonGreeting: "Guten Tag {0},",
      eveningGreeting: "Guten Abend {0},",
      morningGreetingGeneric: "Guten Morgen,",
      afternoonGreetingGeneric: "Guten Tag,",
      eveningGreetingGeneric: "Guten Abend,",
      opening: "Ich bin Nio. Wie kann ich Ihnen helfen?",
      openingPrivacy: "Ich bin Nio.",
      pbIntro1: "Fragen Sie mich nach der Produktivität Ihrer Geräte.",
      alertBeta: "Nio befindet sich in der frühen Beta-Phase. Die Antworten sind derzeit auf Print Beat und Knowledge Zone beschränkt.",
      alertDefault: "Die Antworten sind derzeit auf Print Beat und Knowledge Zone beschränkt.",
      intro2:  "Hier sind einige Fragen, die interessant sein könnten:",
      kzIntro1: "Fragen Sie mich nach Ihren Anliegen und ich werde Ihnen mit Informationen aus der Wissenszone antworten.",
      pbSample1: "Wie produktiv war die Website gestern?",
      pbSample2: "Wie kann ich meine Produktivität verbessern?",
      pbSample3: "Welche Druckmaschine übertrifft die anderen Druckmaschinen?",
      pbSample4: "Welches Substrat hat mir den größten Zeitverlust beschert?",
      pbSample5: "Mit welchem Thema habe ich letzte Woche am meisten Zeit verschwendet?",
      kzSample1: "Wie kann ich den Substratabfall reduzieren und gleichzeitig die Qualität erhalten und die Kosten senken?",
      kzSample2: "Welche HP Indigo Druckmaschine eignet sich am besten für den effizienten, farbkonsistenten Druck von Weinetiketten?",
      kzSample3: "Wie kann ich den Einsatz von Verbrauchsmaterialien optimieren, um die Produktivität zu steigern?",
      kzSample4: "Welche wichtigen Nachhaltigkeitsfaktoren sollte ich beim Drucken berücksichtigen?",
      kzSample5: "Wie kann ich die Farbkonsistenz zwischen meinen HP Indigo 6000 und 20K Druckmaschinen sicherstellen?",
      feedbackTitle: "Grund für Ihr Ergebnis",
      feedbackPlaceholder: "Können Sie im Detail erklären, was passiert ist?",
      fbPositive1: "Die Daten sind korrekt",
      fbPositive2: "Sehr gute Reaktion",
      fbPositive3: "Sehr detailliert",
      fbPositive4: "Antwort war relevant",
      fbOther: "Sonstige",
      fbNegative1: "Die Informationen oder Daten sind falsch",
      fbNegative2: "Die Antwort ging nicht auf meine Frage ein",
      fbNegative3: "Die Antwort war verwirrend oder unklar",
      fbNegative4: "Antwort war nicht relevant",
      feedbackSubmittedTitle: "Vielen Dank für Ihre Rückmeldung!",
      feedbackSubmittedDescription_Positive: "Es freut uns zu hören, dass die Antwort hilfreich war! Ihr Feedback bestärkt uns darin, noch bessere Erfahrungen zu machen.",
      feedbackSubmittedDescription_Negative: "Wir entschuldigen uns für etwaige Unannehmlichkeiten, die dadurch entstanden sind. Unser Team wird die Informationen überprüfen und daran arbeiten, sie zu korrigieren. Wenn Sie weitere Details über den Fehler oder zusätzliches Feedback haben, lassen Sie es uns bitte wissen, damit wir uns verbessern können.",
      ask_Placeholder: "Was möchten Sie wissen?",
      answerCopiedToClipboard: "Antwort in Zwischenablage kopiert",
      feedbackSubmitted: "Feedback abgesendet",
      feedbackCleared: "Feedback entfernt",
      newConversation: "Neuer Chat",
      chatHistory: "Chat-Verlauf",
      submitQuestion: "Frage absenden",
      defaultStopMessage: "Update vom Benutzer abgebrochen.",
      stopQuestion: "Generierung stoppen",
      responseError: "Ups, es sieht so aus, als ob auf unserer Seite ein Problem aufgetreten ist. Bitte versuchen Sie es später noch einmal. Wenn das Problem weiterhin besteht, kontaktieren Sie bitte den Support.",
      responseError400: "Es sieht so aus, als ob Ihre Frage unerwartete Zeichen enthält. Bitte vereinfachen Sie sie und versuchen Sie es erneut.",
      responseError429: "Langsam, langsam. Ich kann nicht mit so vielen Fragen mithalten.",
      like: "Gefällt mir",
      dislike: "Gefällt mir nicht",
      copy: "In Zwischenablage kopieren",
      retry: "Neuer Versuch",
      contact: "Kontaktieren Sie uns",
      contactSubject: "HP Nio Problem",
      contactQuestion: "Frage: {0}",
      noConversations: "Keine Gespräche vorhanden",
      startConversation: "Beginnen Sie ein Gespräch, um hier Ihren Chatverlauf zu sehen",
      today: "Heute",
      yesterday: "Gestern",
      lastWeek: "Letzte Woche",
      older: "Ältere",
      chatDeletePolicy: "Inaktive Chats werden nach 90 Tagen gelöscht.",
      privacyNotice: "Sie interagieren mit einer KI-Lösung. Überprüfen Sie die Antworten, da sie unvollständig oder ungenau sein können.",
      privacy1: "Sie sind im Begriff, sich an einer KI-Lösung zu beteiligen. Chats können überprüft und zum Trainieren unserer Modelle verwendet werden.",
      privacy2: `If you prefer to receive support in another way, please visit {0}.`,
      acceptPrivacy: "Chatten mit HP Nio beginnen",
      deleteConversationTitle: "Chat löschen",
      conversationName: "Konversation",
      deleteConversationConfirm: "Dadurch wird <b>{0}</b> gelöscht.<br>Diese Aktion kann nicht rückgängig gemacht werden.",
      deleteConversationSuccess: "Konversation gelöscht",
      deleteConversationError: "Konversation konnte nicht gelöscht werden",
      renameConversationTitle: "Konversation umbenennen",
      renameConversationMessage: "Name des Gesprächs",
      renameConversationSuccess: "Konversation umbenannt",
      renameConversationError: "Konversation konnte nicht umbenannt werden",
      deleteConversation: "Löschen",
      renameConversation: "Umbenennen",
    },
    apps: {
      title: "Menü",
      externalLinks: "Extern",
      availableApps: "Erkunden",
      configure: "Anpassen",
      showApp: "Anzeigen",
      hideApp: "Verbergen",
      setDefault: "Standardanwendung einstellen",
      setShortcut: "Als angepinnt einrichten",
      removeShortcut: "Nicht mehr anpinnen",
      showAllApps: "Alle Anwendungen anzeigen",
      shortCutTooltip: "Zu {0} navigieren",
      currentAccount: "Aktuelle Organisation",
      goHome: "Zur Startseite",
      goAppHome: "Zur Startseite der Anwendung wechseln",
      byProvider: "nach {0}",
      quickFilter: "Anwendung finden ...",
      allApps: "Alle Anwendungen",
      recentApps: "Vor Kurzem",
      externalApp: "Anwendung außerhalb von PrintOS",
      modeSwitcher: "Dunkel-/Hellmodus",
      goProducts: "Weitere Apps erkunden"
    },
    panels: {
      ai: "HP Nio fragen",
      notifications: "Meine Benachrichtigungen",
      help: "Hilfe und Support",
      user: "Benutzer",
      close: "Bedienfeld schließen",
      moveLeft: "Nach links",
      moveRight: "Nach rechts",
      maximize: "Maximieren",
      restore: "Wiederherstellen",
    },
    user: {
      account: "Organisation",
      returnToHP: "Zurück zu HP Inc.",
      myOrganization: "Meine Organisation",
      myOrganizations: "Meine Organisationen",
      myReports: "Meine Berichte",
      mySettings: "Meine Einstellungen",
      signOut: "Abmelden",
      signInExplanation: "Melden Sie sich bei HP PrintOS an, um Benachrichtigungen und Anwendungen anzuzeigen.",
      signIn: "Anmelden",
      RCDA: "Kundenzugriff",
      orphanUser: "PrintOS-Benutzer",
      orphanContext: "Keine Organisationen",
      deviceUser: "PrintOS-Gerät",
      anonymous: "Anonymer Benutzer",
      name: "Name",
      email: "E-Mail",
      address: "Adresse",
      editUser: "HP Konto bearbeiten",
      viewPrivacy: "Datenschutzerklärung anzeigen"
    },
    date: {
      fewSecondsAgo: "Vor einigen Sekunden",
      minuteAgo: "Vor einer Minute",
      minutesAgo: "{0} Minuten zuvor",
      hourAgo: "Vor einer Stunde",
      hoursAgo: "{0} Stunden zuvor",
      dayAgo: "Vor einem Tag",
      daysAgo: "{0} Tage zuvor",
      monthAgo: "Vor einem Monat",
      monthsAgo: "{0} Monate zuvor",
      yearAgo: "Vor einem Jahr",
      yearsAgo: "{0} Jahre zuvor",
    },
    help: {
      quickFilter: "Suche",
      page: "Seite",
      app: "Anwendung",
      newFeatures: "Neue Funktionen",
      more: "Alle",
      contactHP: "Kontakt zu HP",
      noTopics: "Keine passenden Hilfethemen",
      about: "Info",
      terms: "Dienstleistungsbedingungen",
      readFile: "Dokument",
      stepByStepTutorial: "Lernprogramm",
      goLink: "Anwendungsseite",
      viewVideo: "Video",
      goToUrl: "Link",
      other: "Sonstige",
      faq: "Häufig gefragt",
      new: "Neues Thema",
      whatsNew: "Neuerungen",
      technicalSupport: "PrintOS-Support",
      printOSFeedback: "PrintOS Feedback",
      conversationsWithHP: "Korrespondenz mit HP",
      youMayConsider: "Vielleicht möchten Sie sich noch Folgendes anschauen...",
      myKzArticles: "Meine Artikel im Wissensbereich",
      kzServiceTopics: "{0} ({1})",
      lkcArticles: "Artikel in HP Latex-Wissenszentrale",
    },
    notifications: {
      noNotifications: "Es sind keine Benachrichtigungen vorhanden",
      viewAll: "Alles anzeigen",
      dismiss: "Verwerfen",
      dismissAll: "Alles verwerfen",
      subscriptions: "Einstellungen",
    },
    marketplace: {
      title: "Marktplatz",
      explore: "Alles erkunden",
      featured: "Empfohlen",
      slides: {
        default: {
          description: "Erweitern Sie PrintOS mit Premium-Anwendungen, -Erweiterungen und -Connectors"
        },
        oee: {
          title: "Print Beat OEE",
          description: "Mit echtzeitnahen datengestützten Erkenntnissen den Betrieb laufend optimieren",
        },
      },
      partialProductivitySubscribePreEnforcement_Title: "Der Zugriff auf Indigo Print Beat, Jobs, OEE und Print Beat Services erfordert ab 4. August ein <a href='https:/intercom.help/hp-printos/en/articles/11113950-hp-printos-productivity-power-pack' target='_blank'>Productivity Power Pack Abonnement</a>.",
      partialProductivitySubscribePreEnforcement_Desc: "Daten nicht abonnierter Geräte können bis August extrahiert werden.",
      partialProductivitySubscribePostEnforcement_Title: "Nicht alle Ihre Indigo-Geräte sind für das Productivity Power Pack angemeldet ({0}/{1})",
      partialProductivitySubscribePostEnforcement_Desc: "Geräte ohne Abonnement können Ihr PrintOS-Erlebnis einschränken (Print Beat, OEE, Dashboards, ...)",
      goToMarket_Action: "Zum Marktplatz",
      howToExtract_Action: "Wie kann ich meine Daten extrahieren?"
    },
    focus: {
      title: "Focus",
    },
    locales: {
      "de-DE": "Deutsch",
      "en-GB": "Englisch (UK)",
      "en-US": "Englisch (USA)",
      "es-ES": "Spanisch",
      "fr-FR": "Französisch",
      "it-IT": "Italienisch",
      "ja-JP": "Japanisch",
      "ko-KO": "Koreanisch",
      "pt-PT": "Portugiesisch",
      "tr-TR": "Türkisch",
      "zh-HANS": "Chinesisch (vereinfacht)",
      "ru-RU": "Russisch",
      "PartialTranslation": "Teilweise angefertigte Übersetzungen",
    },
    modal: {
      ok: "OK",
      cancel: "Abbrechen",
    },
    combo: {
      noItems: "Keine Übereinstimmungen",
    },
    nps: {
      question: "Hallo {0}. Wie wahrscheinlich ist es, dass Sie PrintOS einem Kollegen empfehlen?",
      // In case we can't get user's display name
      questionNameless: "Wie wahrscheinlich ist es, dass Sie PrintOS einem Kollegen empfehlen?",
      notLikely: "Überhaupt nicht wahrscheinlich",
      likely: "Äußerst wahrscheinlich",
      send: "Feedback senden",
      response: {
        detractor: "{0}, nennen Sie etwas, das wir bei PrintOS verbessern könnten. Wir freuen uns über jede Rückmeldung.",
        detractorNameless: "Nennen Sie eine Sache, die wir bei PrintOS verbessern könnten. Wir freuen uns über jede Rückmeldung.",
        passive: "{0}, teilen Sie uns mit, wie wir Ihre Erfahrung mit PrintOS noch besser gestalten können. Wir lesen alle Kommentare.",
        passiveNameless: "Teilen Sie uns mit, wie wir Ihre Erfahrung mit PrintOS noch besser gestalten können. Wir lesen alle Kommentare.",
        promoter: "{0}, wir freuen uns sehr darüber, dass Sie PrintOS nutzen. Sagen Sie uns bitte, warum. Wir lesen alle Kommentare.",
        promoterNameless: "Wir freuen uns sehr darüber, dass Sie PrintOS nutzen. Sagen Sie uns bitte, warum. Wir lesen alle Kommentare.",
      },
      introMorning: "Guten Morgen {0}, ich bin Jon, der Customer Success Manager für PrintOS.",
      introMorningNameless: "Guten Morgen, ich bin Jon, der Customer Success Manager für PrintOS.",
      introAfternoon: "Guten Tag {0}, ich bin Jon, der Customer Success Manager für PrintOS.",
      introAfternoonNameless: "Guten Tag, ich bin Jon, der Customer Success Manager für PrintOS.",
      introEvening: "Guten Abend {0}, ich bin Jon, der Customer Success Manager für PrintOS.",
      introEveningNameless: "Guten Abend, ich bin Jon, der Customer Success Manager für PrintOS.",
      intro2: "Beantworten Sie bitte die folgende Frage, damit ich Ihre Erfahrung mit PrintOS einschätzen kann.",
      intro3: "Wie wahrscheinlich ist es, dass Sie PrintOS einem Kollegen empfehlen?",
      detractorResponse: "Vielen Dank für Ihre Antwort, {0}!  Wir schätzen sowohl positives als auch kritisches Feedback.",
      detractorResponseNameless: "Vielen Dank für Ihre Antwort!  Wir schätzen sowohl positives als auch kritisches Feedback.",
      promoterResponse: "Vielen Dank {0}! Es freut uns sehr, dass Sie ein PrintOS Fan sind. Ihr Feedback trägt dazu bei, den Nutzungskomfort weiter zu optimieren.",
      promoterResponseNameless: "Vielen Dank! Es freut uns sehr, dass Sie ein PrintOS Fan sind. Ihr Feedback trägt dazu bei, den Nutzungskomfort weiter zu optimieren.",
      response2: "Bitte wählen Sie eine Anwendung und sagen Sie uns, wie wir PrintOS weiter für Sie verbessern können.",
      response3: "Alle Kommentare werden vom Customer Success-Team gelesen.  Wir könnten uns mit Ihnen in Verbindung setzen, um Ihr Feedback besser zu verstehen.",
      feedbackPlaceholder: "Sie können PrintOS weiter verbessern, indem Sie...",
      application: "Anwendung",
      noApplication: "PrintOS - Allgemeines Feedback"
    },
    subscription: {
      title: "Abonnement",
      subscribe: "Jetzt abonnieren",
      noticeSingular: "Ihr {0}-Abonnement  läuft in {1} Tag ab.",
      notice: "Ihr {0}-Abonnement läuft in {1} Tagen ab.",
    },
    promotion: {
      label: "Aktion",
      title: "Aktionsphase – Hinweis",
      notice: "Sie befinden sich in der Werbeaktionsphase für diese Anwendung.",
    },
    trial: {
      label: "Testversion läuft in Kürze ab.",
      title: "Testzeitraum",
      noticeSingular: "{0} ist in einer Testphase. Ihre Testversion läuft in {1} Tag ab.",
      notice: "{0} ist in einer Testphase. Ihre Testversion läuft in {1} Tagen ab.",
    },
    subscriptionExpired: {
      label: "Abonnement abgelaufen",
      title: "Abonnement abgelaufen",
      notice: "Ihr Abonnement für {0} ist abgelaufen. Nach einer kurzen Übergangsphase können Sie nicht mehr auf diese Funktionalität zugreifen.",
    },
    trialExpired: {
      label: "Testversion abgelaufen",
      title: "Testphase abgelaufen",
      notice: "Ihre Testphase für {0} ist abgelaufen. Nach einer kurzen Übergangsphase können Sie nicht mehr auf diese Funktionalität zugreifen.",
    },
    hpWarning: "{0}\nSie sind ein HP Inc.-Vertreter in einer Kundenorganisation. Seien Sie bitte vorsichtig.",
    role: {
      HP_Operation: "HP Operation",
      HP_Sales_and_Marketing: "HP mit Kundenkontakt",
      SystemRoleGenesis_Admin: "PrintOS-Service-Admin",
      SystemRoleGenesis_Support: "HP Inc. Admin",
      SystemRoleGenesis_R_AND_D: "Genesis F&E",
      CE_Level_1: "CE Level 1",
      CE_Level_2: "CE Level 2",
      Application_Engineer: "Anwendungstechniker",
      Ramp_Up_Engineer: "Anlaufphasentechniker",
      Support_Engineer: "Support-Techniker",
      Remote_Support_Engineer: "HP-Support-Techniker",
      Specialist: "Spezialist",
      Certification_Centers: "Zertifizierungsstellen",
      Supplies_and_Media_Personnel: "Personal für Verbrauchsmaterialien und Medien",
      Supplies_and_Media_Admin: "Admin von Verbrauchsmaterialien und Medien",
      HP_Service: "HP Service",
      HP_Training: "HP Schulung",
      Admin: "Administrator",
      Pre_Press_Operator: "Benutzer",
      Press_Operator: "Bediener",
      Dashboard: "Dashboard",
      Channel_Sales_and_Marketing: "Channel Vertrieb und Marketing",
      Channel_Operation: "Channel Operation",
      Channel_CE_Level_1: "Channel-Kundentechniker-Ebene 1",
      Channel_CE_Level_2: "Channel-Kundentechniker-Ebene 2",
      HP_Read_Only: "HP Schreibgeschützt",
      Reseller_Manager: "Fachhändler-Manager",
      Business_Partner_Manager: "Geschäftspartner-Manager",
      Call_Center: "Callcenter",
      Field_Engineer: "Außendiensttechniker",
      ThreeD_Business_Manager: "3D Business Manager",
      HPInPsp: "HP in PSP",
      ChannelInPsp: "Kanal in PSP",
      GenericAdmin: "Administrator",
      GenericUser1: "Benutzerebene 1",
      GenericUser2: "Benutzerebene 2",
      Generic_Read_Only: "Schreibgeschützt",
      ThreeD_Care_Center: "3D-Kundendienstzentrum",
      ThreeD_Cost_Calculator: "3D-Kosten",
      Composer_External: "Begrenzter Zugriff – Composer",
      SIM_External: "Begrenzter Zugriff – Verbrauchsmaterialienbestands-Manager",
      Multiple: "Mehrere Rollen"
    },
    inlineAlerts: {
      Http_429_Error: "Starker Datenverkehr",
      Http_429_Description: "Der Service ist im Moment außergewöhnlich ausgelastet. Einige Funktionen sind möglicherweise vorübergehend nicht verfügbar. Aktualisieren Sie die Seite, um es erneut zu versuchen.",
      Http_429_Action: "Aktualisieren",
      NewSubscription: "Neues Abonnement - {0}",
      NewSubscriptionDescription: "Ihre Organisation hat ein neues Abonnement.",
      NewSubscriptionAction: "Mehr Infos",
      SubscriptionExpired: "Abonnement abgelaufen - {0}",
      SubscriptionExpiredDescription: "Ihr Abonnement läuft am {0} ab.",
      SubscriptionExpiredAction: "Abonnement ansehen",
      Subscription30DayWarning: "Abonnement wird ablaufen - {0}",
      Subscription30DayWarningDescription: "Ihr Abonnement läuft in {0} Tagen am {1} ab.",
      Subscription30DayWarningAction: "Abonnement ansehen",
      Subscription15DayWarning: "Abonnement läuft bald ab - {0}",
      Subscription15DayWarningDescription: "Ihr Abonnement läuft in {0} Tagen am {1} ab.",
      Subscription15DayWarningAction: "Abonnement ansehen",
      JoinOrgRequestAccepted: "Anfrage zum Beitritt zur Organisation akzeptiert",
      JoinOrgRequestAcceptedDescription: "Ihnen wurde Zugriff auf <b>{0}</b> gewährt.",
      JoinOrgRequestSwitch: "Offene Organisation",
      JoinOrgRequestDenied: "Anfrage zum Beitritt zur Organisation abgelehnt",
      JoinOrgRequestDeniedDescription: "Der Administrator hat Ihre Anfrage auf Beitritt zu <b>{0}</b> abgelehnt.",
      NonHPContext: "Nicht-HP-Kontextfenster öffnen",
      NonHPContextDescription: "Kontext: {0}",
      CloseContext: "Kontext schließen"
    },
    ui: {
      Confirm: "Bestätigen",
      Notify: "Benachrichtigung",
      OpenImage: "Bilddatei öffnen",
      Dismiss: "Verwerfen",
      CheckingContext: "Überprüfung des Kontexts...",
      LoadingContext: "Wiederherstellung von {0}..."
    }
  }
};
